import { NotFoundException } from "../customExceptions";
import Loader from "@material-ui/core/CircularProgress";
import trimString from "../helpers/trimString";
import { useGetAdOpsCampaign } from "../queries/adOpsCampaigns";
import { ENTITY } from "../constants";

export const AdOpsCampaignBreadcrumb = ({ match }) => {
  // Entity
  const { ADOPSCAMPAIGN } = ENTITY;

    const {
      data: adOpsCampaign,
      isLoading,
      isError,
      error,
    } = useGetAdOpsCampaign(match.params.adOpsCampaignId);
  
    if (isLoading) {
      //return <span>Loading...</span>;
      return <Loader color="primary" size={18} sx={{ mr: 1 }} />;
    }
  
    if (isError && error instanceof NotFoundException) {
      return <span>Not found</span>;
    }
  
    if (adOpsCampaign) {
      return <span>{trimString(adOpsCampaign[ADOPSCAMPAIGN.nameField], 20)}</span>;
    }
  
    return null;
  };